<template>
  <div id="myPage">
    <div class="one-part">
      <div class="one-button" @click="service('咨询课程详情','')">
        <p>咨询课程详情</p>
        <!-- <a href="tel:400-8555-686">咨询课程详情</a> -->
      </div>
    </div>
    <div class="two-part">
       <!-- 课程咨询 -->
      <div class="one-button" @click="service('课程咨询','')">
        <p>课程咨询</p>
        <!-- <a href="tel:400-8555-686">课程咨询</a> -->
      </div>
      <div class="one-button" @click="purchaseButton('立即购买','')">
        立即购买
      </div>
      <!-- 申请试听 -->
      <div class="audition">
        <van-field
          v-model="purchasePhone"
          @click="phoneFocus('免费申请试听')"
          center
          clearable
          :border="false"
          use-button-slot
          placeholder="请输入手机号"
          class="inputPhone"
          type="tel"
        />
        <div class="audition-button" @click="handleAuditionFree('免费申请试听','')">
          免费申请试听
        </div>
      </div>
      <!-- 咨询课程大纲 -->
       <div class="three-button" @click="service('项目咨询','')">
         <p>项目咨询</p>
        <!-- <a href="tel:400-8555-686">咨询课程大纲</a> -->
      </div>
    </div>
    <div class="three-part">
      <!-- 点击咨询 -->
      <div class="one-button" @click="service('点击咨询','晋升受阻的职场人')">
        <p>点击咨询</p>
        <!-- <a href="tel:400-8555-686">点击咨询</a> -->
      </div>
      <div class="one-button" @click="service('点击咨询','进入AI新行业的你')">
        <p>点击咨询</p>
        <!-- <a href="tel:400-8555-686">点击咨询</a> -->
      </div>
      <div class="one-button" @click="service('点击咨询','数据分析学习者')">
        <p>点击咨询</p>
        <!-- <a href="tel:400-8555-686">点击咨询</a> -->
      </div>
      <div class="one-button" @click="service('点击咨询','在校学生/毕业生')">
        <p>点击咨询</p>
        <!-- <a href="tel:400-8555-686">点击咨询</a> -->
      </div>

      <div class="bottom">
        <div class="item" @click="service('报考咨询','')">
          <p>报考咨询</p>
          <!-- <a href="tel:400-8555-686">报考咨询</a> -->
        </div>
        <div class="border"></div>
        <div class="item" @click="handleAudition('申请试听','')">申请试听</div>
      </div>
    </div>

    <van-dialog
        class="receiveDialog"
        v-model="receiveDialogVisible"
        :showConfirmButton="false"
        :closeOnClickOverlay = "true"
        width="15.733rem"
    >
        <van-cell-group class="call" v-if="audition">
            <van-field v-model="tel" type="tel" label="" @click="phoneFocus(buttonType==1?'立即购买':buttonType==3?'申请试听':'')" placeholder="请输入手机号码" />
        </van-cell-group>
        <div class="massage">
            <van-cell-group class="captcha">
                <van-field v-model="captcha" type="number" @input="writeCode(buttonType==1?'立即购买':buttonType==2?'免费申请试听':'申请试听')" label="" placeholder="请输入验证码" />
            </van-cell-group>
            <div class="obtain" :class="Countdown == 0?'':'active'" @click="obtain">{{VerificationStatus}}</div>
        </div>
        <div class="receive" @click="receive(captcha,buttonType==1?'立即购买':buttonType==2?'免费申请试听':'申请试听')">立即领课</div>
    </van-dialog>
    <van-dialog
        class="cutScreenDialog"
        v-model="warningDialogVisible"
        :showConfirmButton="false"
        :closeOnClickOverlay = "true"

        width="13rem"
    >
        <div v-if="success">
            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/right.png" alt="">
            <span>申请成功课程顾问与您联系</span>
        </div>
        <div v-else>
            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/wrong.png" alt="">
            <span>您已申请成功 请勿重复提交</span>
        </div>
    </van-dialog>
    <!-- 获取验证码  免费申请试听-->
    <!-- <van-dialog v-model="showAuditionFree" class="dialog"  :showConfirmButton="false" >
      <div class="authcodeInputWrapper">
        <van-field
          class="inputAuth"
          v-model="purchasePhone"
          center
          clearable
          :border="false"
          use-button-slot
          placeholder="请输入验证码"
        />

        <div class="getVerificationStyle fr" @click="postAccountGetAuthCode" :style="{color:Countdown>0? '#BBBBBB':'#fff'}">
          {{VerificationStatus}}
        </div>

        <div class="clear"></div>
      </div>

      <div class="pick-course-button">
        立即领课
      </div>

    </van-dialog> -->
    <!-- 获取验证码  立即购买-->
    <!-- <van-dialog v-model="showPurchase" class="dialog"  :showConfirmButton="false" >
      <div class="authcodeInputWrapper">
        <van-field
          class="input"
          v-model="purchasePhone"
          center
          clearable
          :border="false"
          use-button-slot
          placeholder="请输入手机号"
        />
      </div>
      <div class="authcodeInputWrapper">
        <van-field
          class="inputAuth"
          v-model="purchasePhone"
          center
          clearable
          :border="false"
          use-button-slot
          placeholder="请输入验证码"
        />

        <div class="getVerificationStyle fr" @click="postAccountGetAuthCode" :style="{color:Countdown>0? '#BBBBBB':'#fff'}">
          {{VerificationStatus}}
        </div>

        <div class="clear"></div>
      </div>

      <div class="pick-course-button">
        立即领课
      </div>

    </van-dialog> -->
     <!-- 获取验证码  申请试听-->
    <!-- <van-dialog v-model="showAudition" class="dialog"  :showConfirmButton="false" >
      <div class="authcodeInputWrapper">
        <van-field
          class="input"
          v-model="purchasePhone"
          center
          clearable
          :border="false"
          use-button-slot
          placeholder="请输入手机号"
        />
      </div>
      <div class="authcodeInputWrapper">
        <van-field
          class="inputAuth"
          v-model="purchasePhone"
          center
          clearable
          :border="false"
          use-button-slot
          placeholder="请输入验证码"
        />

        <div class="getVerificationStyle fr" @click="postAccountGetAuthCode" :style="{color:Countdown>0? '#BBBBBB':'#fff'}">
          {{VerificationStatus}}
        </div>

        <div class="clear"></div>
      </div>

      <div class="pick-course-button">
        立即领课
      </div>

    </van-dialog> -->
    <!-- 领取成功  -->

    
    

    <!-- 跳转订单页面 -->
    <!-- 倒计时 -->
    <!-- <div>{{timeArr[0]}} -- {{timeArr[1]}} -- {{timeArr[2]}}</div> -->

    <!-- 轮播 -->
    <!-- <van-swipe style="height:50px" autoplay="2000" :show-indicators="false" vertical>
      <van-swipe-item>
        <div class="swipe-content">
          111
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="swipe-content">
          222
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="swipe-content">
          333
        </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="swipe-content">
          444
        </div>
      </van-swipe-item>
    </van-swipe> -->


  </div>
</template>
<script>
/*eslint-disable*/
const isPhone = /^1(?:3[0-9]|4[5-9]|5[0-9]|6[12456]|7[0-8]|8[0-9]|9[0-9])[0-9]{8}$/;
export default {
  name: 'aiCourse',
  data() {
    return {
      captcha: '', // 验证码
      Countdown: 0,
      purchaseId: '', // 立即领取商品id
      auditionFreeId: '', // 免费申请试听id
      audtionId: '', // 申请试听id
      agentId: '',
      purchasePhone: '', // 免费申请试听
      tel: '', // 弹框tel
      success: false,
      receiveDialogVisible: false, // 输入手机号验证码提示框
      warningDialogVisible: false, // 领取成功/重复领取提示框
      audition: false,
      buttonType: null, // 立即领课按钮 type 1,2,3 
      token: '',
      handelPaylist: {},
    }
  },
  computed: {
    VerificationStatus () {
      if (this.Countdown) {
        return `重新获取 ${this.Countdown}s`
      } else {
        return '发送验证码'
      }
    },
  },
  created(){
     this.token = localStorage.getItem("token")
          ? localStorage.getItem("token")
          : null;
      // sessionStorage.setItem('distributionId', null)
      // sessionStorage.setItem('goodsId', '382')
      // sessionStorage.setItem('goodsId2', '383')
      // sessionStorage.setItem('goodsId3', '384')
      this.purchaseId  = this.getQueryString('goodsId') || sessionStorage.getItem('goodsId')
      this.auditionFreeId  = this.getQueryString('goodsId2') || sessionStorage.getItem('goodsId2')
      this.audtionId  = this.getQueryString('goodsId3') || sessionStorage.getItem('goodsId3')

      this.agentId =  this.getQueryString('distributionId') || sessionStorage.getItem('distributionId')
      sessionStorage.setItem('distributionId', this.agentId)
      sessionStorage.setItem('goodsId', this.purchaseId)
      sessionStorage.setItem('goodsId2', this.auditionFreeId)
      sessionStorage.setItem('goodsId3', this.audtionId)
     
  },

  mounted() {
    

  },
  methods: {
  phoneFocus(scene){
      this.$sensors.track('click_phone_number_input',{
	        current_page: "正式课", 
	        current_scene: scene, 
      })
    },
    writeCode(scene){
      if(this.buttonType==1&&this.captcha.length==6 || this.buttonType==3&&this.captcha.length==6){
        this.$sensors.track('get_verification_code',{
	        current_page: "正式课", 
	        current_scene: scene, 
          phone_number:this.tel,
          is_succeed:1,
          failed_reason:''
        })
      }
      if(this.buttonType==2&&this.captcha.length==6){
        this.$sensors.track('get_verification_code',{
	        current_page: "正式课", 
	        current_scene: scene, 
          phone_number:this.purchasePhone,
          is_succeed:1,
          failed_reason:''
        })
      }
    },
    // 客服
    service(scene,consult){
      window.qimoChatClick()
      this.$sensors.track('click_button',{
	        current_page: "正式课", 
	        button_name: scene, 
          consult:consult
      })
      this.$sensors.track('course_consult',{
	        current_page: "正式课", 
	        current_scene: scene, 
	        consult: consult,
          is_succeed:1
      })
    },
    async getFindUserBranchList (scene) {
        localStorage.removeItem('branchList')
        localStorage.removeItem('code')
        localStorage.removeItem('organ')
        localStorage.removeItem('actor')
        localStorage.removeItem('branch')
        localStorage.removeItem('channel')
        return this.$api.account.getFindUserBranchList({}).then(res => {
            if (res.data && res.data.length) {
                this.branchList = res.data.filter(item => Object.prototype.toString.call(item) === '[object Object]').map(item => {
                    return {
                        text: item.name,
                        value: item.branch,
                        actor: item.actor,
                        organ: item.organ,
                        channel: item.channel,
                        code: item.code
                    }
                })
                if (!this.branchList.length) return
                localStorage.setItem('branchList', JSON.stringify(this.branchList))
                !localStorage.getItem('code') && localStorage.setItem('code', res.data[0].code)
                !localStorage.getItem('organ') && localStorage.setItem('organ', res.data[0].organ)
                !localStorage.getItem('actor') && localStorage.setItem('actor', res.data[0].actor)
                !localStorage.getItem('branch') && localStorage.setItem('branch', res.data[0].branch)
                !localStorage.getItem('channel') && res.data[0].channel && localStorage.setItem('channel', res.data[0].channel)
                this.$sensors.login(res.data[0].code)
                
                // 发送请求判断是否已购买
                if(this.buttonType === 1) {
                  this.getApplyStaus(this.purchaseId);
                  this.checkUserCanByGoods(this.purchaseId,scene);

                } else if(this.buttonType === 2) {
                  this.checkUserCanByGoods(this.auditionFreeId,scene);

                } else if(this.buttonType === 3) {
                  this.checkUserCanByGoods(this.audtionId,scene);

                }
            }
        })
    },
    // 立即领取
    purchaseButton(button_name,consult) {             
      this.Countdown = 0
      
      // 
      this.buttonType = 1
      this.tel = null;
      this.captcha = null;
      this.receiveDialogVisible = true
      // 
      this.audition = true
      this.$sensors.track('click_button',{
	        current_page: "正式课", 
	        button_name: button_name, 
          consult:consult
      })
    },
    handleAuditionFree(button_name,consult) {
      this.$sensors.track('click_button',{
	        current_page: "正式课", 
	        button_name: button_name,
          consult:consult 
      })
      if(!isPhone.test(this.purchasePhone)) { // 
        this.$toast({
            message: '请输入手机号',
            position: 'top',
        });  
        return
      }
      this.Countdown = 0
       this.buttonType = 2
      this.tel = null;
      this.captcha = null;
      this.receiveDialogVisible = true
      // 

      this.audition = false

    },
    handleAudition(button_name,consult) {
      this.$sensors.track('click_button',{
	        current_page: "正式课", 
	        button_name: button_name, 
          consult:consult
      })
      this.Countdown = 0
      this.buttonType = 3
      this.tel = null;
      this.captcha = null;
      this.receiveDialogVisible = true
      // 
      this.audition = true
    },
    // 剩余时间
    calculateTime() {
      // 剩余时间
      var now= new Date();
      //截止时间
      var until= new Date(this.stopDate);
      var days = (until- now)/1000/3600/24; 
      var day = Math.floor(days);
      var hours = (days - day)*24;
      var hour = Math.floor(hours);
      var minutes = (hours - hour)*60;
      var minute = Math.floor(minutes);
      // var seconds = (minutes - minute)*60;
      // var second = Math.floor(seconds);
      return [day,hour,minute]
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    
    setCountdown () {
      clearInterval(this.countdownInterval)

      this.countdownInterval = setInterval(() => {
        this.Countdown--
        if (this.Countdown <= 0) {
          this.Countdown = 0
          clearInterval(this.countdownInterval)
        }
      }, 1000)
    },
    getApplyStaus(id) {         
        this.$api.initTrainingIdx.getApplyStatus(
            {
                goodsId: id
            }
            ).then((res) => {
            if (res.data) { 
                this.goodsInfor = res.data         
            }  else {
                this.$toast({
                    message: res.message,
                    duration: 4000,
                    position: 'top',
                }); 
            }
        })        


    },
    //查看商品是否购买；
    checkUserCanByGoods(id,scene) {
      let params = {
          goodsId: id
      };
      this.$api.home.checkUserCanByGoods({ params }).then(data => {
          this.isStudy = data.data;
          if (this.isStudy == true) {
              // 未购买
              //  this.payment(id).then(res => {
              //     if (res.data) {
              //         this.handelPaylist = res.data;
              //         this.handelPay();  
                                       
              //     } else {
              //         this.$toast({
              //             message: res.message,
              //             duration: 4000,
              //             position: 'top',
              //         });                    
              //     }
              //   });
              if(this.buttonType === 1 || this.buttonType === 3){
                  this.$sensors.track('get_course',{
	                current_page: "正式课", 
	                current_scene: scene, 
                  phone_number:this.tel,
                  is_succeed:1,
                  failed_reason:''
                  })
                }
              if(this.buttonType === 2){
                this.$sensors.track('get_course',{
	              current_page: "正式课", 
	              current_scene: scene, 
                phone_number:this.purchasePhone,
                is_succeed:1,
                failed_reason:''
                })
              }
              if(this.buttonType === 1) { // 跳转订单页
                this.payment(id).then(res => {
                  if (res.data) {
                      this.handelPaylist = res.data;
                      this.handelPay();     
                      // 跳转订单页面

                  } else {
                      this.$toast({
                          message: res.message,
                          duration: 4000,
                          position: 'top',
                      });                    
                  }
                });

              } else {
                this.payment(id).then(res => {
                  if (res.message === 'success') {
                    this.receiveDialogVisible = false

                    this.warningDialogVisible = true;
                    this.success = true
                                     
                  } else {
                      this.$toast({
                          message: res.message,
                          duration: 4000,
                          position: 'top',
                      });                    
                  }
                });
                this.receiveDialogVisible = false

                this.warningDialogVisible = true;
                this.success = true
                // this.$router.push('/home')
              }
          } else if (this.isStudy == false) {
              // 已购买
              // this.$toast("请勿重复提交");
              // this.warningDialogVisible = true;
              // this.success = false;
              this.warningDialogVisible = true;
              this.success = false
              this.receiveDialogVisible = false
              if(this.buttonType === 1 || this.buttonType === 3){
                  this.$sensors.track('get_course',{
	                current_page: "正式课", 
	                current_scene: scene, 
                  phone_number:this.tel,
                  is_succeed:0,
                  failed_reason:'您已申请成功，请勿重复提交'
                  })
                }
              if(this.buttonType === 2){
                this.$sensors.track('get_course',{
	              current_page: "正式课", 
	              current_scene: scene, 
                phone_number:this.purchasePhone,
                is_succeed:0,
                failed_reason:'您已申请成功，请勿重复提交'
                })
              }
          }else{
            if(this.buttonType === 1 || this.buttonType === 3){
                  this.$sensors.track('get_course',{
	                current_page: "正式课", 
	                current_scene: scene, 
                  phone_number:this.tel,
                  is_succeed:0,
                  failed_reason:data.message
                  })
                }
            if(this.buttonType === 2){
              this.$sensors.track('get_course',{
	            current_page: "正式课", 
	            current_scene: scene, 
              phone_number:this.purchasePhone,
              is_succeed:0,
              failed_reason:data.message
              })
            }
          }
      });
    },
    payment(id) {
        return this.$api.initTrainingIdx
            .placeOrder({
                // 调用订单号
                data: {
                    goodsId: id,
                    orderSource: 2,
                    agentId: this.agentId + ''
                }
            })
    },
    handelPay() {
      this.$api.home
          .prePayOrder({
              // 调用订单号
              data: {
                  orderId: this.handelPaylist.id,
                  orderNo: this.handelPaylist.orderNo,
                  totalMoney: this.goodsInfor.salePrice,
                  payInfoDesc: "",
                  scene: this.getWx ? 101 : 4
              }
          })
          .then(res => {
              if (res.message === "success") {
                  let hostname = window.location.hostname
                  let port = window.location.port;
                  let isIP=/^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
                  let arr =  hostname.split('.');
                  let isDTYProEnv = !hostname.split('.').splice(3).join('.'); //线上的定制化主题

                  let API = arr[0].includes('hrss') ?  `https://pay.${arr.splice(1).join('.')}` : `https://pay.${isDTYProEnv ? arr.splice(1).join('.') : arr.splice(2).join('.')}`
                  
                  if(isIP.test(hostname) || hostname.includes('dev') || !!port){
                      API = 'http://localhost:8080';
                  }   
                  // const pathUrl = window.location.href.split('com')[1]
                  window.open(API  + "/cashier?orderNo=" + this.handelPaylist.orderNo + '&token=' + localStorage.getItem('token') + '&organ=' + localStorage.getItem('organ') + '&actor=' + localStorage.getItem('actor') + '&branch=' + localStorage.getItem('branch') + '&referId=' + this.handelPaylist.goodsList[0].referId + '&backUrl=' + window.location.origin +"&id=" + this.purchaseId + "&referId=" + this.handelPaylist.goodsList[0].referId + '&theme=gongxin&type=pay2&agentId=' + this.agentId + `&id2=${this.auditionFreeId}&id3=${this.audtionId}&consult='立即购买'&isMaiDian=1&phone=${this.tel}`, '_self');
              }
          });

    },


    WeiXin() {
        // 判断是否是微信内置浏览器
        let isWeiXin = () => {
            return (
                navigator.userAgent
                    .toLowerCase()
                    .indexOf("micromessenger") !== -1
            );
        };
        if (isWeiXin()) {
            return true;
        } else {
            return false;
        }
    },
    obtain() {
        if(this.Countdown>0) {
          return
        }
        let data = {};
        if(this.audition) { // 弹框输手机号码
          if(!isPhone.test(this.tel)) {
            this.$toast(
              {
                  message: '手机号格式错误',
                  position: 'top',
              });
            return
          }

          data = { phone: this.tel, distributionId: this.agentId }
        } else {
          if(!isPhone.test(this.purchasePhone)) {
            this.$toast(
              {
                  message: '手机号格式错误',
                  position: 'top',
              });
            return
          }
          
          data = { phone: this.purchasePhone, distributionId: this.agentId }
        }
        
        this.$api.usercenter.postAccountGetAuthCode({ data }).then(res => {
            if (res.data) {
                // this.$textTip('验证码已发送')
                // this.$toast(
                // {
                //     message: '验证码已发送',
                //     position: 'top',
                // });
                this.Countdown = 60
                this.setCountdown()
                // this.$store.state.userInfo.phone = this.purchasePhone
                // sessionStorage.setItem("WdPhone", this.phone);
                // this.$router.push({ name: 'verificationCode' , query: {name: this.$route.query.name}})
            } else {
              this.Countdown = 0
            }
        })
    },
    async receive(captcha,scene) {
      
      if (captcha) {
        // if(!this.token) {
        //   this.postAccountLoginByAuthCode()
        // } else {
        //   // 发送请求判断是否已购买
        //   if(this.buttonType === 1) {
        //     this.getApplyStaus(this.purchaseId);
        //     this.checkUserCanByGoods(this.purchaseId);

        //   } else if(this.buttonType === 2) {
        //     this.checkUserCanByGoods(this.auditionFreeId);

        //   } else if(this.buttonType === 3) {
        //     this.checkUserCanByGoods(this.audtionId);

        //   }
        // }
        this.postAccountLoginByAuthCode(scene)
      } else {
        

        if(this.buttonType === 2) {
          this.$toast(
            {
              message: "请输入验证码",
              position: 'top',
            }
          );
        } else if(this.buttonType === 1 ||  this.buttonType === 3) {
          if(!isPhone.test(this.tel)) {
            this.$toast(
              {
                message: "请输入手机号",
                position: 'top',
              }
            );
          } else {
            this.$toast(
              {
                message: "请输入验证码",
                position: 'top',
              }
            );
          }
        }
      }
    },
    apply() {
        if (this.token) {
            // 发送请求判断是否已购买
            this.checkUserCanByGoods(this.goodsId);
        } else {
            this.audition = true;
            this.receiveDialogVisible = true;
        }
        
    },
     // 登录注册
    async postAccountLoginByAuthCode (scene) {
        let data = {}
        if(this.buttonType === 1) { // 立即购买
          data = {
            account: this.tel,
            authCode: this.captcha,
            distributionId: this.agentId
          };
          
        } else if(this.buttonType === 2) { // 申请免费试听
          data = {
            account: this.purchasePhone,
            authCode: this.captcha,
            distributionId: this.agentId
          };
        } else if(this.buttonType === 3) { // 申请试听
           data = {
            account: this.tel,
            authCode: this.captcha,
            distributionId: this.agentId
          };
        }
        await this.$api.usercenter
            .postAccountLoginByAuthCode({ data })
            .then(async res => {
                if (res.code != 0) {
                    if(this.buttonType === 1 || this.buttonType === 3){
                      this.$sensors.track('get_course',{
	                          current_page: "正式课", 
	                          current_scene: scene, 
                            phone_number:this.tel,
                            is_succeed:res.success?1:0,
                            failed_reason:res.message
                      })
                    }
                    if(this.buttonType === 2){
                      this.$sensors.track('get_course',{
	                          current_page: "正式课", 
	                          current_scene: scene, 
                            phone_number:this.purchasePhone,
                            is_succeed:res.success?1:0,
                            failed_reason:res.message
                      })
                    }
                    this.$notify(res.message);
                    return false;
                }
                if (res.data) {
                    localStorage.setItem("token", res.data);
                    this.token = res.data;
                    await localStorage.setItem(
                        "WDuserInfo",
                        JSON.stringify(this.$store.state.userInfo)
                    );
                    this.purchasePhone = null;
                    // this.purchasePhone2 = null;
                    this.tel = null;
                    this.captcha = null;
                    this.receiveDialogVisible = false;
                    this.getFindUserBranchList(scene);
                    // this.getApplyStaus(this.goodsId);
                    // // 发送请求判断是否已购买
                    // this.checkUserCanByGoods(this.goodsId);
                } else {
                    return res.data;
                }
            })
            .catch(() => {
              if(this.buttonType === 1 || this.buttonType === 3){
                this.$sensors.track('get_course',{
	                current_page: "正式课", 
	                current_scene: scene, 
                  phone_number:this.tel,
                  is_succeed:0,
                  failed_reason:'验证码错误'
                })
              }
              if(this.buttonType === 2){
                  this.$sensors.track('get_course',{
	                current_page: "正式课", 
	                current_scene: scene, 
                  phone_number:this.purchasePhone,
                  is_succeed:0,
                  failed_reason:'验证码错误'
                  })
                }
                this.$toast(
                    {
                        message: "验证码错误",
                        position: 'top',
                    });
                return false;
            });
    },
   

    
  },
  beforeDestroy() {
    clearInterval(this.countdownInterval)
  },
  components: {
  }
}
/*eslint-disable no new*/
</script>
<style lang="stylus" scoped>
  
    
  #myPage
    width 100vw
    .one-part
      width 100%
      height 1836px
      background-image url('https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/one.png')
      background-repeat no-repeat
      background-size 100%
      position relative
      .one-button
        position absolute
        left 50%
        margin-left -260px
        top 885px
        width 521px
        height 99px
        background: linear-gradient(180deg, #2a1ce6, #3000b0);
        // background-color #3560E8
        box-shadow: 0px 5px 5px 0px #5F5F5F; 
        border-radius 38px
        font-size: 36px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-style: italic;
        color: #FFFFFF;
        text-shadow: 0px 5px 10px rgba(184, 48, 22, 0.3);
        text-align center 
        line-height 99px
        p
          color white
  
    .two-part
      width 100%
      height 3090px
      background-image url('https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/two.png')
      background-repeat no-repeat
      background-size 100%
      position relative
      .one-button
        position absolute
        left 434px
        top 280px
        width: 238px;
        height: 61px;
        background: linear-gradient(180deg, #59DBA4, #45C6E9);
        box-shadow: 0px 3px 3px 0px #5F5F5F;
        border-radius: 31px;
        font-size: 29px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #FFFFFF;
        text-shadow: 0px 3px 2px #5F5F5F;
        text-align center 
        line-height 61px
        a
          color white
        &:nth-child(2)
          top 390px
      .audition
        position absolute 
        top 800px 
        width 100vw
        display flex 
        flex-direction column
        align-items center 
        justify-content center
        
        .inputPhone
          width: 469px;
          height: 81px;
          background: #FFFFFF;
          box-shadow: 0px 3px 3px 0px rgba(3, 0, 0, 0.59);
          border-radius: 14px;
        .audition-button
          width: 471px;
          height: 81px;
          background: linear-gradient(180deg, #59DBA4, #45C6E9);
          box-shadow: 0px 3px 3px 0px #5F5F5F;
          border-radius: 14px;
          font-size: 35px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 35px;
          text-shadow: 0px 3px 2px #5F5F5F
          line-height 81px
          text-align center
          margin-top 30px
      .three-button
        position absolute
        left 50%
        margin-left -260px
        bottom 1030px
        width 521px
        height 99px
        background: linear-gradient(180deg, #2a1ce6, #3000b0);
        background-color #3560E8
        box-shadow: 0px 5px 5px 0px #5F5F5F; 
        border-radius 38px
        font-size: 36px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-style: italic;
        color: #FFFFFF;
        text-shadow: 0px 5px 10px rgba(184, 48, 22, 0.3);
        text-align center 
        line-height 99px
        p
          color white
          letter-spacing 4px
        
    .three-part
      width 100%
      height 1690px
      background-image url('https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/gongxin/three.png')
      background-repeat no-repeat
      background-size 100%
      position relative
      .one-button
        width: 266px;
        height: 69px;
        text-align center
        background: linear-gradient(180deg, #2a1ce6, #3000b0);
        box-shadow: 0px 3px 3px 0px #5F5F5F;
        border-radius: 34px
        font-size: 29px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 69px;
        text-shadow: 0px 3px 2px #5F5F5F
        position absolute 
        a
          color white
        &:nth-child(1)
          left 86px
          bottom 588px
        &:nth-child(2)
          right 86px
          bottom 588px
        &:nth-child(3)
          left 86px
          bottom 262px
        &:nth-child(4)
          right 86px
          bottom 262px
      .bottom
        position fixed
        left 0
        bottom 0
        right 0
        width 100vw 
        height 129px
        display flex 
        align-items center 
        background: linear-gradient(180deg, #3fb8f3, #386aff);
        .item 
          flex 1
          height 129px
          text-align center 
          font-size: 41px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-style: italic;
          color: #FFFFFF;
          line-height: 129px;
          text-shadow: 0px 2px 4px rgba(36, 36, 36, 0.69);
          // box-shadow: 2px 4px 4px 0px rgba(7, 0, 105, 0.64);
          p
            color white
        .border 
          width 2px
          height 100%
          background-color #fff
  .authcodeInputWrapper{
    display flex
    align-items center
    justify-content space-between
    margin-bottom 28px
  }
  .VerificationStyle{
    width 420px
  }
  .getVerificationStyle{
    width: 227px;
    height: 94px;
    background: linear-gradient(180deg, #3864FF, #40C9F0);
    // box-shadow: 2px 4px 5px 0px rgba(17, 0, 110, 0.64);
    border-radius: 16px;
    font-size: 34px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 94px;
    text-shadow: 1px 2px 2px rgba(108, 71, 0, 0.4);
    text-align center

  }

.dialog
  width 695px
  // height 439px
  border-radius 16px
  box-sizing border-box
  padding 50px 35px
  // display flex 
  // justify-content space-between

.van-cell
  padding 0 0 0 10px
.input
  width: 620px;
  height: 94px;
  background: #FFFFFF;
  border: 1px solid rgba(103, 103, 103, 0.46);
  // box-shadow: 0px 2px 6px 0px rgba(54, 54, 54, 0.51);
  border-radius: 16px;
.inputAuth
  width: 381px;
  height: 94px;
  background: #FFFFFF;
  border: 1px solid rgba(103, 103, 103, 0.46);
  // box-shadow: 0px 2px 6px 0px rgba(54, 54, 54, 0.51);

.pick-course-button
  text-align center 
  line-height 94px
  width: 621px;
  height: 94px;
  background: linear-gradient(180deg, #FF7C2B, #FFA44B, #FFC05C);
  box-shadow: 1px 2px 2px 0px rgba(108, 71, 0, 0.4);
  border-radius: 16px;
  font-size: 38px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #FFFFFF;
  text-shadow: 1px 2px 2px rgba(108, 71, 0, 0.4);

.receiveDialog {
    padding: 50px;
    .call.van-cell-group {
        height: 40px;
        border-radius: 0.53333rem;
        overflow: hidden;
        border: 1px solid #BFBFBF;
        box-shadow: 0px 1px 2px 0px rgba(3, 0, 0, 0.35);
        margin-bottom: 14px;
        .van-cell {
            padding: 9px 16px;
        }
    }
    .massage {
        display: flex;
        justify-content: space-between;
        .captcha.van-cell-group {
            width: 160px;
            height: 40px;
            border-radius: 0.53333rem;
            overflow: hidden;
            border: 1px solid #BFBFBF;
            box-shadow: 0px 1px 2px 0px rgba(3, 0, 0, 0.35);
            margin-bottom: 14px;
            .van-cell {
                padding: 9px 16px;
            }
        }
        .obtain {
            width: 240px;
            height: 86px;
            background: linear-gradient(180deg, #3ebaf2, #3869fe);
            box-shadow: 0px 2px 2px 0px rgba(17, 0, 110, 0.64);
            border-radius: 0.53333rem;
            text-align: center;
            font-size: 28px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 86px;
            text-shadow: 1px 3px 3px rgba(108, 71, 0, 0.4);
            &.active {
              background: rgba(3, 0, 0, 0.35)
            }
        }
    }
    .receive {
        height: 86px;
        background: linear-gradient(180deg, #ffbc5a, #ff9b44, #ff812f);
        box-shadow: 1px 3px 3px 0px rgba(108, 71, 0, 0.4);
        border-radius: 0.53333rem;
        text-align: center;
        font-size: 28px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 86px;
        text-shadow: 1px 3px 3px rgba(108, 71, 0, 0.4);
    }
  }
  .cutScreenDialog {
      padding: 50px;
      text-align: center;
      img {
          width: 90px;
          display: block;
          padding: 30px 0 40px;
          margin: 0 auto;
      }
      span {
          display: block;
          font-size: 28px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #5F5F5F;
          margin-bottom: 20px;
      }
  }
  
</style>


